module.exports = __webpack_public_path__ + "static/img/no-card.676cf89c.png";